// Library pass: games under /books/html/ and /books/_swf/ load only with a short-lived cookie the
// server hands out when a game is opened here (src/server/lib/play-pass.js). The cookie is
// HttpOnly, so this module only remembers when it last asked. Each open asks again, so the pass
// follows the student to a new network; the game waits only when there is no recent pass.

const FRESH_MS = 30 * 60 * 1000; // the server's pass lasts 2 h
const WAIT_MS = 3000; // never hold a game back longer than this
let at = 0;
let pending = null;

export const isGamePath = (u) => typeof u === "string" && /^\/books\/(?:html|_swf)\//.test(u);

function ask() {
	if (!pending) {
		pending = fetch("/__rv/play", { method: "POST", credentials: "same-origin", cache: "no-store" })
			.then((r) => { if (r.ok) at = Date.now(); })
			.catch(() => {})
			.finally(() => { pending = null; });
	}
	return pending;
}

// Resolves once a pass is in place (or after a short wait if the server can't be reached, so a
// game is never stuck: it then shows its own "open from Re:Vault" page, which asks again).
export function playPass() {
	const p = ask();
	if (Date.now() - at < FRESH_MS) return Promise.resolve();
	return Promise.race([p, new Promise((r) => setTimeout(r, WAIT_MS))]);
}

// Asks ahead of a click that must open a window at once (an isolate title in a new tab).
export function warmPlayPass() {
	if (Date.now() - at >= FRESH_MS) ask();
}

// A game left open keeps its pass, and a network change gets a new one before the game's next file:
// while hasGame() says a game tab is open, asks again every 5 minutes, when the browser comes back
// online, and when the tab is shown again. (The service worker also heals a refused game file on
// its own, sw/play-heal.js, which covers the desktop and any other frame showing /books/.)
const KEEP_MS = 5 * 60 * 1000;
const SHOWN_GAP_MS = 60 * 1000;
export function keepPlayPass(hasGame) {
	const maybe = () => { try { if (hasGame()) ask(); } catch (e) { void e; } };
	setInterval(maybe, KEEP_MS);
	addEventListener("online", maybe);
	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState === "visible" && Date.now() - at >= SHOWN_GAP_MS) maybe();
	});
}
